import React from "react";
import { cn } from "./cn";
import { StarIcon } from "../../../assets/ui/icons";

/* Membership pill. Membership is NOT a profile status — it is the subscription a company bought. It rides beside the business name and never inside a... */
export const MemberPill = ({ className = "" }) => (
  <span
    className={cn(
      "inline-flex items-center gap-1 h-5 px-2 rounded-full border",
      "text-[11px] font-bold tracking-[.02em] whitespace-nowrap font-sans",
      "bg-[var(--gold-soft)] text-[var(--gold-deep)] border-[var(--gold-border)]",
      className
    )}
  >
    <StarIcon />
    Member
  </span>
);

export default MemberPill;
